export default __webpack_public_path__ + "static/media/img-slider-asaph-2.bf65b0a5.png";